export const NOTE_NAMES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];

export function getNoteFromFrequency(frequency) {
    if (!frequency || frequency < 20) return "-";

    const noteNum = 12 * (Math.log(frequency / 440) / Math.log(2));
    const midi = Math.round(noteNum) + 69;

    if (midi < 0) return "-";

    const note = NOTE_NAMES[midi % 12];
    const octave = Math.floor(midi / 12) - 1;

    return `${note}${octave}`;
}
